import PropTypes from "prop-types";

const EmailBasic = ({ children }) => (
  <a
    href="mailto:me@cadenf.com"
    className="section-link"
    target="_blank"
    rel="noopen noreferrer"
    title="Email Caden Finkelstein"
    aria-label="Email Caden Finkelstein"
  >
    me@cadenf.com
    {children}
  </a>
);

EmailBasic.propTypes = {
  children: PropTypes.any,
};

export default EmailBasic;
